import { useContext } from 'react';

import { LanguageContext } from '../Contexts/index';

const useLanguage = () => {
  const context = useContext(LanguageContext);

  return context;
};

export default useLanguage;
